import React from 'react'
import styled from 'styled-components'
import { connect } from 'react-redux'
import { Segment, Grid } from 'semantic-ui-react'
import moment from 'moment'
import flowRight from 'lodash/flowRight'
import { date as dateFormatter, dateTime as dateTimeFormatter } from 'loankeeper-common/helpers/formatters'
import { Files } from 'WebAPI'
import { deleteClientRiskLevel } from '../../../../store/client'
import { withUserConfig, withConstantPermissions } from 'shared'
//@ts-ignore
import LKGrid from 'shared/LKGrid'
//@ts-ignore
import { GridContainer, SegmentGroup, FlexTableChild, TableContainer } from 'shared/StyledComponents'
//@ts-ignore
import withLivedata from 'shared/containers/withLivedata'
//@ts-ignore
import LKModal, { actions as LKModalActions } from 'shared/LKModal'
import withCallAPI from 'loankeeper-common/containers/withCallAPI'
import { actions as DetailsContainerActions, constants as DCConstants } from '../../../DetailsContainer'
import ClientRiskLevelModal, { ClientRiskLevelModalTrigger } from '../../../ClientRiskLevelModal'
import { formName, risksObjectName } from '../../constants'
import { translateCmd, translateLKMessage } from '../../helpers'
import { AMLRiskProps, AMLRiskState, risk } from '../../types'

const WrappedSegmentGroup = styled(SegmentGroup)`
  height: 50% !important;
`

const config = {
  gridIdentity: {
    formName,
    objectName: risksObjectName,
  },

  syncGridState: true,
  enableColumnsResize: true,
  enableColumnsOrder: true,
  enableRowSelection: true,

  columnConfigs: {
    Amount: {
      cellStyle: { textAlign: 'right' },
    },
    OperDate: {
      valueFormatter: ({ value }) => dateFormatter(value),
    },
    CDate: {
      valueFormatter: ({ value }) => dateTimeFormatter(value),
    },
  },
}

const CONFIRMATION_MODAL_NAME = 'ClientDetailsDeleteRiskLevelConfirmation'

@withLivedata('OpenDayStatus.Open_Day as OpenDay')
//@ts-ignore
@withConstantPermissions('EDIT_CLIENT_RISKLEVELS as CanEditClientRiskLevel')
//@ts-ignore
@connect(undefined, (dispatch, { ID, hash }) => ({
  openConfirmation: (RiskLevelID: number) => {
    dispatch(
      LKModalActions.openConfirmation(CONFIRMATION_MODAL_NAME, {
        RiskLevelID,
      }),
    )
  },
  openAmlDetails: (AMLDetails: risk) =>
    dispatch(LKModalActions.open({ name: 'ClientRiskLevelModal', type: 'details', AMLDetails })),

  deleteRiskLevel: ({ RiskLevelID }: { RiskLevelID: number }) =>
    dispatch(
      //@ts-ignore
      deleteClientRiskLevel({
        ClientID: ID,
        HashSum_ClientID_: hash,
        ID: RiskLevelID,
      }),
    )
      //@ts-ignore
      .then((response) => {
        if (deleteClientRiskLevel.fulfilled.match(response)) {
          dispatch(
            DetailsContainerActions.fetchPage({
              type: 'Client',
              ID,
              hash,
              page: 'risks',
            }),
          )
        }
      })
      .catch((error) =>
        dispatch(LKModalActions.openError(translateLKMessage(error.Error.Message || error.Error.Text))),
      ),
}))
class Risks extends React.Component<AMLRiskProps, AMLRiskState> {
  state = {
    loading: false,
  }

  DecoratedModal = flowRight(
    withUserConfig('ID as UserID'),
    //@ts-ignore
    withCallAPI({
      APICall: Files.view,
      renderChildrenWhileLoading: true,
      APIParams: () => ({ ID: this.props.ID, hash: this.props.hash }),
    }),
  )(ClientRiskLevelModal)

  getContextMenu = ({ node: { data } }: { node: { data: risk } }) => {
    return [
      {
        name: translateCmd('entry_details'),
        action: () => this.props.openAmlDetails(data),
        icon: 'info',
        permissionKey: 'LFL_VIEW',
      },
      {
        name: translateCmd('delete_risklevel'),
        action: () => this.props.openConfirmation(data.ID),
        icon: 'delete',
        disabled: moment(data.OperDate).isBefore(moment(this.props.OpenDay)),
        permissionKey: 'EDIT_CLIENT_RISKLEVELS',
      },
    ]
  }

  getRowStyle = ({
    node: {
      data: { OperDate },
    },
  }) => {
    if (moment(OperDate).isBefore(moment(this.props.OpenDay))) {
      return { color: 'gray' }
    }

    return {}
  }

  handleDeleteRiskLevel = (values: { RiskLevelID: number }) => {
    this.setState({ loading: true })
    this.props.deleteRiskLevel(values).then(() => {
      this.setState({ loading: false })
    })
  }

  render() {
    const { ID, hash, CanEditClientRiskLevel } = this.props
    const { loading } = this.state
    const { risks, linkedfiles } = this.props.data
    return (
      <WrappedSegmentGroup>
        <SegmentGroup>
          <LKModal.Confirmation
            name={CONFIRMATION_MODAL_NAME}
            onConfirm={this.handleDeleteRiskLevel}
            loading={loading}
            warning
          />

          <Segment.Group>
            <FlexTableChild>
              <TableContainer>
                <LKGrid
                  rowData={risks}
                  getContextMenuItems={this.getContextMenu}
                  getRowStyle={this.getRowStyle}
                  {...config}
                  instanceName={`${DCConstants.DetailsGridPrefixes.client}-${ID}-Risks`}
                />
              </TableContainer>
            </FlexTableChild>

            {CanEditClientRiskLevel && (
              <Segment>
                <GridContainer>
                  <Grid>
                    <Grid.Row>
                      <Grid.Column textAlign="left" width={16}>
                        {/* @ts-ignore */}
                        <ClientRiskLevelModalTrigger>{translateCmd('add_risklevel')}</ClientRiskLevelModalTrigger>

                        <ClientRiskLevelModal ID={ID} hash={hash} linkedfiles={linkedfiles} />
                      </Grid.Column>
                    </Grid.Row>
                  </Grid>
                </GridContainer>
              </Segment>
            )}
          </Segment.Group>
        </SegmentGroup>
      </WrappedSegmentGroup>
    )
  }
}

export default Risks
